import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const ButtonRed = styled(Button)({
  backgroundColor: "#e50218",
  borderRadius: "10px",
  fontSize: "14px",
  padding: "0 16px",
  minHeight: "0px !important",
  textTransform: "none !important",
  fontWeight: 600,
  // width: "fit-content",
  height: "38px",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#e50218 !important",
  },
});

export default ButtonRed;
